'use strict';

var Marionette = require('backbone.marionette');
var TunnelView = require('components/remoteSites/TunnelView');

module.exports = Marionette.CollectionView.extend({
  childView: TunnelView,
});
